//import awjquery from 'jquery';
import uuid from 'uuid/v4';
import HostDetectionModule from './HostDetectionModule';
//import JQueryAppear from './JQueryAppear';
//import AppearModule from './AppearModule';
import {encodeParam, css2Text} from './util';

let modalDiv;

export default class InitModule {

  static init() {

    window.addEventListener("message", InitModule.receivePostMessage);

    let dwHost = HostDetectionModule.detectDynamicWidgetHost();
    //console.log('dwHost', dwHost);

    let elements = document.getElementsByClassName('adsbyaperza');
    for (let i = 0; i < elements.length; i++) {
      let insEl = elements[i];
      if (!insEl.id) {
        InitModule.initInsElement(insEl, dwHost);
      }
    }

    // awjquery('ins.adsbyaperza').each((index, insEl) => {
    //   if (!insEl.id) {
    //     InitModule.initInsElement(insEl, dwHost);
    //   }
    //   //InitModule.appearInsElement(insEl);
    // })

    //JQueryAppear.info();
  }

  static receivePostMessage(event) {
    let data = event.data;
    if (data && data.adFrameId && data.height) {
      let adFrame = window.document.getElementById(data.adFrameId);
      if (adFrame.style.height !== '100%') {
        adFrame.style.height = data.height;
      }
    }
  }

  static initInsElement(insEl, dwHost) {

    let id = uuid();
    insEl.id = `aw-ins-${id}`;

    let type = insEl.getAttribute('data-ad-type') || 'EC';

    let width = parseInt(insEl.style.width) || parseInt(insEl.getAttribute('data-ad-width')) || undefined;
    //console.log('initInsElement width', width);
    if (width) {
      if (!String(width).endsWith('px')) {
        width = width + 'px';
      }
    } else {
      width = '100%';
    }

    let defaultHeight = 300;
    if (type.toLowerCase() === 'ec') {
      defaultHeight = undefined;
    }


    let height = parseInt(insEl.style.height) || parseInt(insEl.getAttribute('data-ad-height')) || defaultHeight;

    if (height) {
      if (!String(height).endsWith('px')) {
        height = height + 'px';
      }
    } else {
      height = '100%';
    }

    let params = {
      adFrameId: `aw-${id}`,
      mode: insEl.getAttribute('data-ad-mode') || 'frame',
      type: type,
      modelNumber: insEl.getAttribute('data-ad-model-number'),
      seriesName: insEl.getAttribute('data-ad-series-name'),
      keywords: insEl.getAttribute('data-ad-keywords'),
      clientId: insEl.getAttribute('data-ad-client-id'),
      sellerProductModelId: insEl.getAttribute('data-ad-seller-product-model-id'),
      cluezCatalogId: insEl.getAttribute('data-ad-cluez-catalog-id'),
      styleHeight: height,
      styleWidth: width,
      segments: insEl.getAttribute('data-ad-segments'),
      limit: insEl.getAttribute('data-ad-limit'),
      lang: insEl.getAttribute('data-ad-lang'),
      mfrBrandId: insEl.getAttribute('data-ad-mfr-brand-id'),
      test: insEl.getAttribute('data-ad-test'),
    };

    let src = `${dwHost}/widget?` + encodeParam(params);

    //console.log('insElement src', src);

//     var html = `
// <iframe style="width:${width};height:${height};border-width:0px" src="${src}" onload="$aperzaWidget.registerIFrame(this);"></iframe>
// `;

    let html = `
<iframe id="${params.adFrameId}" style="width:${width};height:${height};border-width:0px" src="${src}"></iframe>
`;


    let mode = insEl.getAttribute('data-ad-mode') || 'frame';
    if (mode.toLowerCase()==='modal') {
      if (!modalDiv) {
        modalDiv = InitModule.createModalDiv(insEl, height, width, html);
      }

      insEl.addEventListener('click', function() {
        document.getElementById('adsbyaperza-modal-content').innerHTML = html;
        document.getElementById('adsbyaperza-modal').style.display='block';
      });
    } else if (mode.toLowerCase()==='fluid') {
      let request = new XMLHttpRequest();
      request.open('GET', src);
      request.responseType = 'text';

      request.onload = function() {
        insEl.innerHTML = request.response;
      };

      request.send();
    } else {
      insEl.innerHTML = html;
    }
  }

  // static appearInsElement(insEl) {
  //   JQueryAppear.register();
  //   $(insEl).appear({
  //     force_process: true,
  //   });
  //
  //   $(insEl).one('appear', function(event, $all_appeared_elements) {
  //     AppearModule.appear(event.target);
  //   });
  //
  // }

  static createModalDiv(insEl, styleHeight, styleWidth, html) {
    let modalDiv = document.createElement('div');
    modalDiv.id='adsbyaperza-modal';
    modalDiv.style.cssText = css2Text({
      display: 'none',
      position: 'fixed',
      'z-index': 1,
      left: 0,
      width: '100%',
      top: 0,
      height: '100%',
      overflow: 'auto',
      'background-color': ['rgb(0,0,0)', 'rgba(0,0,0,0.4)'],
    });

    let modalContent = document.createElement('div');
    modalContent.id='adsbyaperza-modal-content';
    modelContent.style.cssText = css2Text({
      'background-color': '#fefefe',
      margin: '15% auto',
      padding: '0px',
      border: '0px solid #888',
      width: styleWidth + 'px',
      height: styleHeight + 'px',
    });

    // let modalClose = document.createElement('span');
    // modalClose.style.cssText = 'color: #aaa;float: right;font-size: 28px;font-weight: bold;';
    // modalClose.innerHTML='&times;';

    // modalClose.onclick = function() {
    //   modalDiv.style.display = 'none';
    // }

    //modalContent.appendChild(modalClose);
    modalDiv.appendChild(modalContent);

    modalDiv.addEventListener('click', function() {
      modalDiv.style.display = 'none';
    });

    document.body.appendChild(modalDiv);

    return modalDiv;
  }

}
